<div
  class="gcc-timepicker dropdown"
  bsDropdown
  [isOpen]="isDropdownOpen"
  [isDisabled]="isDisabled"
  (click)="onDropdownToggle($event)"
>
  <div class="form-control dropdown clickable d-flex align-items-center">
    <div class="flex-grow-1">
      <input
        type="text"
        class="hours"
        maxlength="2"
        placeholder="00"
        [value]="hours"
        [disabled]="isDisabled"
        (focus)="onHoursFocus()"
        (input)="onHoursChange($event)"
        #hoursInput
      />
      <span class="separator">:</span>
      <input
        type="text"
        class="minutes"
        maxlength="2"
        placeholder="00"
        [value]="minutes"
        [disabled]="isDisabled"
        (focus)="onMinutesFocus()"
        (blur)="onMinutesBlur()"
        (input)="onMinutesChange($event)"
        #minutesInput
      />
      <input
        *ngIf="showMeridian"
        type="text"
        class="meridian"
        maxlength="2"
        placeholder="AM"
        readonly
        [disabled]="isDisabled"
        [value]="meridian"
        (focus)="onMeridianFocus()"
        #meridianInput
      />
    </div>
    <i class="icon icon-clock text-gray"></i>
  </div>
  <div class="dropdown-menu note" role="menu" *dropdownMenu>
    <div [ngSwitch]="viewMode" class="row px-1" [ngClass]="{ 'px-1': viewMode !== 'a' }">
      <ng-template ngSwitchCase="h">
        <div
          *ngFor="let h of hourOptions"
          (click)="onHoursSelect(h)"
          class="dropdown-item text-center clickable col-4"
          role="menuitem"
        >
          {{ h }}
        </div>
      </ng-template>
      <ng-template ngSwitchCase="m">
        <div
          *ngFor="let m of minuteOptions"
          (click)="onMinutesSelect(m)"
          class="dropdown-item text-center clickable col-6"
          role="menuitem"
        >
          {{ m }}
        </div>
      </ng-template>
      <ng-template ngSwitchCase="a">
        <div
          *ngFor="let m of meridianOptions"
          (click)="onMeridianSelect(m)"
          class="dropdown-item px-3 clickable"
          role="menuitem"
        >
          {{ m }}
        </div>
      </ng-template>
    </div>
  </div>
</div>
